import { useCoreValues } from '../api/use-core-values';

export interface AuthoritativeFinalPrefill {
  readonly price: number;
  readonly weightMt: number;
}

// The authoritative Final Settlement figures: once BOTH the side's price and
// weight are final on the value log, the dialog prefills final weight × fixed
// price from the log instead of the ticket-reference estimate. Null whenever
// the log has no double-final side (flag off, no records, or still
// provisional) — callers then keep the existing non-authoritative prefill.
export function useAuthoritativeFinalPrefill(
  blOrderId: string,
  side: 'buy' | 'sell',
): AuthoritativeFinalPrefill | null {
  const direction = side === 'buy' ? 'Purchase' : 'Sale';
  const { data } = useCoreValues(blOrderId);
  const state = data?.sides.find((entry) => entry.side === direction);
  if (state === undefined || !state.price.is_final || !state.weight_mt.is_final) return null;
  const price = Number(state.price.final);
  const weightMt = Number(state.weight_mt.final);
  if (!Number.isFinite(price) || !Number.isFinite(weightMt)) return null;
  return { price, weightMt };
}
